import { themes } from './Theme';

const Themes = Object.freeze({
  light: themes.light,
  dark: themes.dark,
  default: themes.light
});

export default Themes;
